import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount } from 'vue';
import { ModuleName } from '@/types/module-type';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { FitIcon } from '@tencent/wphk-ui';
import { useConfigStore } from '@/store';
import { getJumpUrl } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-recommend',
  props: {
    moduleName: null
  },
  emits: ['onHideModule'],
  setup(__props: any, { emit }) {

const props = __props as { moduleName: ModuleName }




// store
const { getConfig } = useConfigStore();

const list = ref<any[]>([]);

onBeforeMount(async () => {
  const { list: listVal } = await getConfig(props.moduleName);
  list.value = listVal;
  if (!list.value.length) {
    emit('onHideModule', props.moduleName);
  }
});

return { __sfc: true,props, emit, getConfig, list, MultiJumpContainer, FitIcon, getJumpUrl }
}

})